import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import { LazySidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { opsSettingsLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { productsJsmIncidentCommandCenterRoute } from '@jira/router-routes__products-jsm-incident-command-center-routes/src/productsJsmIncidentCommandCenterRoute.tsx';
import { incidentCommandCenterOnboardingEntryPoint } from '@jira/servicedesk__incident-command-center-onboarding/src/incidentCommandCenterOnboarding.entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const entryPoint = createPageEntryPoint({ main: incidentCommandCenterOnboardingEntryPoint });

export const productsJsmIncidentCommandCenterRouteEntry: Route = createEntry(
	productsJsmIncidentCommandCenterRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.jsm-incident-command-center',

		entryPoint: () =>
			fg('jsm_incident_command_center_onboarding') ? entryPoint : notFoundPageEntrypoint,

		layout: opsSettingsLayout,

		navigation: {
			menuId: MenuIdSettings,
			sidebarId: SidebarIdOperationsGeneralConfiguration,
		},

		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],

		forPaint: [LazySidebarContent, LazyAtlassianNavigation],

		meta: {
			reporting: {
				id: 'products-jsm-incident-command-center',
				packageName: 'jiraRouterRoutesProductsJsmIncidentCommandCenterEntries',
				teamName: 'ITOps Phantom',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
